import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {UserQuery} from "./user.query";
import {MesApiService} from "../../mes-api.service";
import {ApiResponse} from "../../api-response/api-response.model";
import {BaseIdModel} from "../../models/base-id.model";
import {map} from "rxjs/operators";
import {plainToInstance} from "class-transformer";
import {UsersStore} from "./user.store";

@Injectable({
  providedIn: 'root'
})
export class UserService extends MesApiService {
  constructor() {
    super('user');
  }

  getCurrent(): Observable<ApiResponse<UserQuery>> {
    return this.getSingle<UserQuery>({ action: 'Current' });
  }
}
